import { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@hausgold/designsystem';
import DynamicIcon from '../../components/Functional/DynamicIcon.js';
import { FIELD_TYPE_CHOICE } from '../../utils/CONSTANTS.js';
import { ApiContext, WizardContext } from '../../utils/contexts.js';
import Renderer from './Fields/Renderer.js';
import NavigationButtons from './NavigationButtons.js';
import { getStep, getStepKeys, shouldShowNavigationButtons } from '../../services/models/dialog.js';
import FluidMaxContainer from '../../components/FluidMaxContainer.js';
import { jsx } from '@emotion/react';
var Step = function Step(_ref) {
  var _step$options;
  var lineKey = _ref.lineKey,
    stepKey = _ref.stepKey;
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    _useContext2$componen = _useContext2.components,
    WizardHeading = _useContext2$componen.WizardHeading,
    RendererLayoutContainer = _useContext2$componen.RendererLayoutContainer;
  var step = getStep(data, lineKey, stepKey);
  var steps = getStepKeys(data, lineKey);
  var shouldAddMandatoryMarker = (step === null || step === void 0 ? void 0 : step.type) === FIELD_TYPE_CHOICE && (step === null || step === void 0 || (_step$options = step.options) === null || _step$options === void 0 ? void 0 : _step$options.mandatory);
  var stepTitle = (step === null || step === void 0 ? void 0 : step.title) + (shouldAddMandatoryMarker ? ' *' : '');
  var icon = step === null || step === void 0 ? void 0 : step.icon;
  var iconSvg = step === null || step === void 0 ? void 0 : step.icon_svg;
  return jsx(Fragment, null, jsx("div", {
    className: "wizard-question",
    "data-line": lineKey,
    "data-step": stepKey
  }, jsx(WizardHeading, null, stepTitle), icon !== null && jsx(Box, {
    textAlign: "center",
    display: {
      base: 'none',
      sm: 'inherit'
    },
    mb: 12
  }, jsx(DynamicIcon, {
    iconId: icon,
    iconSvg: iconSvg,
    h: "56px",
    w: "auto"
  })), jsx(FluidMaxContainer, null, jsx(RendererLayoutContainer, null, jsx(Renderer, {
    key: stepKey,
    stepKey: stepKey,
    lineKey: lineKey
  })))), shouldShowNavigationButtons(data) && jsx(FluidMaxContainer, null, jsx(NavigationButtons, {
    totalSteps: steps === null || steps === void 0 ? void 0 : steps.length,
    currentStepIndex: (step === null || step === void 0 ? void 0 : step.position) - 1,
    stepKey: stepKey,
    stepType: step === null || step === void 0 ? void 0 : step.type
  })));
};
Step.propTypes = {
  lineKey: PropTypes.string.isRequired,
  stepKey: PropTypes.string.isRequired
};
export { Step as default };